module.exports = __webpack_public_path__ + "static/img/ic_dot_red.0585a8e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/ic_dot_red.png
// module id = tl1T
// module chunks = 1